<template>
    <div
        class="md-sold-estimate broker"
        :class="isMobileSize ? 'mobile' : 'pc'"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div v-if="cmpTitle" class="mg-title" v-html="formatFontSize(cmpTitle, '--mg-title-size')"></div>
            <div class="box">
                <p class="text">{{ $t('md-sold-estimate.estprice') }}</p>
                <p class="est-price">{{ estPriceValue }}</p>
                <p class="diff-price" v-if="diffPrice && diffValueDesc">
                    <span
                        class="value"
                        :class="{
                            up: diffPrice > 0,
                            down: diffPrice < 0
                        }"
                    >{{ diffPriceValue }}</span
                    >
                    <span class="desc">{{ diffValueDesc }}</span>
                </p>
            </div>
            <p class="price-desc">{{ cmpDesc }}</p>
            <div class="request">
                <button @click="openRegisterPop">
                    {{ cmpRequestButtonText }}
                </button>
            </div>
        </module-box>
    </div>
</template>

<script>
import commonMixin from '../index';
import common from '../common';
export default {
    mixins: [commonMixin, common],
}
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
.md-sold-estimate.broker {
    text-align: center;
    .box {
        width: 100%;
        background: #f7f7f7;
        border-radius: 4px;
        border-top: 6px solid var(--color-theme);
        .text {
            font-size: 12px;
            color: #505050;
        }
        .est-price {
            font-size: 36px;
            color: #191919;
            font-family: var(--font-bold);
        }
        .diff-price {
            font-size: 16px;
            .value {
                &.down {
                    font-family: var(--font-bold);
                    color: #ff4444;
                }
                &.up {
                    font-family: var(--font-bold);
                    color: #29cb97;
                }
            }
            .desc {
                color: #191919;
            }
        }
    }
    .price-desc {
        line-height: 1.67;
        font-size: 12px;
        color: #505050;
    }
    .request button {
        text-align: center;
        text-transform: uppercase;
        cursor: pointer;
        font-size: 16px;
        border-radius: 5px;
        padding: 10px 20px;
        min-width: 195px;
    }
    &.pc {
        .box {
            height: 180px;
            padding-top: 40px;
        }
        .price-desc {
            margin-top: 25px;
        }
        .request button {
            margin-top: 12px;
            font-family: var(--font-bold);
            @include color-button();
        }
    }
    &.mobile {
        .box {
            height: 130px;
            padding-top: 18px;
        }
        .price-desc {
            margin-top: 12px;
        }
        .request button {
            margin-top: 10px;
            @include color-button-border();
            @include color-button-color();
            background: transparent;
        }
    }
}
</style>
